module.exports = __webpack_public_path__ + "img/tripcancel.c1cbeaa1.png";